import React from 'react';

import StatsContainer from '../Stats/StatsContainer';

function Stats() {
  return <StatsContainer />;
}

export default Stats;
